import { Suspense } from "react";
import { Spinner } from "reactstrap";
import { AnimatePresence, motion } from "motion/react";
import "./style.scss";
import { Link } from "react-router-dom";
import ImageOrVideo from "../ImageOrVideo";
import { useNews } from "../../hooks/NewsHooks";
import { getSlug } from "../../utils/CmsUtils";
import classNames from "classnames";
import RenderWhenInView from "../../functional-components/RenderWhenInView";
import { News } from "../../types/News";

const NewsGrid = ({
  news,
  compact = false
}: {
  news: News;
  compact?: boolean;
}) => {
  return (
    <div className={classNames("news-grid", { compact: compact })} role="list">
      <AnimatePresence initial={false}>
        {news.map(news => (
          <motion.div
            role="listitem"
            key={news.id}
            className={classNames("news-preview", { compact: compact })}
            initial={{
              opacity: 0
            }}
            animate={{
              opacity: 1
            }}
            exit={{
              opacity: 0
            }}
            transition={{
              type: "spring",
              damping: 50,
              stiffness: 400,
              mass: 1
            }}
          >
            <Link to={"/news/" + news.id + "-" + getSlug(news.heading)}>
              <div className="preview-container">
                <div className="news-image">
                  <RenderWhenInView key={news.id}>
                    <ImageOrVideo
                      image={news.image}
                      centerImage={true}
                      preferredStyles={["thumbnail_large", "medium"]}
                    />
                  </RenderWhenInView>
                </div>
                <div
                  className={classNames("news-content", {
                    "content-fade": !compact
                  })}
                >
                  {!compact && (
                    <div className="news-date">{news.publishedAt}</div>
                  )}
                  <h4 className="news-heading">{news.heading}</h4>
                  {!compact && (
                    <div className="news-summary">{news.summary}</div>
                  )}
                </div>
              </div>
            </Link>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export const NewsGridWithQuery = ({ limit = 6, compact = false }) => {
  const news = useNews(limit);

  return <NewsGrid news={news} compact={compact} />;
};

export const CockpitNewsGrid = ({ limit = 6, compact = false }) => {
  return (
    <Suspense fallback={<Spinner />}>
      <NewsGridWithQuery limit={limit} compact={compact} />
    </Suspense>
  );
};

export default NewsGrid;
